<div class="container-fluid">

  <!-- Header -->
  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <h2 class="fw-bold mb-0">GENERAL LEDGER</h2>
    </div>

    <div class="col-md-6 text-md-end mt-2 mt-md-0">
      <button
        pButton
        icon="pi pi-refresh"
        label="REFRESH"
        class="btn btn-primary btn-sm me-2"
        (click)="getDetails()">
      </button>

      <button
        pButton
        icon="pi pi-file-excel"
        label="EXPORT TO EXCEL"
        class="btn btn-danger btn-sm"
        (click)="exportExcel()">
      </button>
    </div>
  </div>

  <!-- Card -->
  <p-card class="shadow-sm border-0">

    <!-- Filters Row -->
    <div class="row g-3">

      <!-- Date Range -->
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
        <label class="form-label mb-0 fw-semibold">Date range</label>
        <p-calendar
          [(ngModel)]="dateRange"
          selectionMode="range"
          dateFormat="yy-mm-dd"
          inputStyleClass="form-control w-100"
          appendTo="body"
          style="width: 100%">
        </p-calendar>
        </div>


        <!-- Quick Buttons -->
        <!-- <div class="d-flex flex-wrap gap-2 mt-2">
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('today')">Today</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('7days')">Last 7 Days</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('30days')">Last 30 Days</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('thisMonth')">This Month</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('lastMonth')">Last Month</button>
        </div> -->
      </div>

      <!-- Location -->
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
        <label class="form-label fw-semibold">Location</label>
        <p-multiSelect
          [options]="locations"
          optionLabel="displayName"
          display="chip"
          [(ngModel)]="selectedLocations"
          appendTo="body"
          style="width: 100%"
          class="w-100">
        </p-multiSelect>
        </div>
      </div>

      <!-- Accounts -->
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
        <label class="form-label fw-semibold">Accounts</label>
        <p-multiSelect
          [options]="accounts"
          optionLabel="displayText"
          display="chip"
          [(ngModel)]="selectedAccounts"
          appendTo="body"
          style="width: 100%"
          class="w-100">
        </p-multiSelect>
        </div>
      </div>
    </div>

    <!-- Summary -->
    <div class="row text-center mt-4 fw-bold">
      <div class="col-md-4">
        DEBIT <span class="text-danger ms-2">{{ debit | number:'1.2-2' }}</span>
      </div>
      <div class="col-md-4">
        CREDIT <span class="text-danger ms-2">{{ credit | number:'1.2-2' }}</span>
      </div>
      <div class="col-md-4">
        BALANCE <span class="text-danger ms-2">{{ closingBalance | number:'1.2-2' }}</span>
      </div>
    </div>

    <!-- Table -->
    <p-table
      [value]="purchaseDetail"
      class="mt-4"
      tableStyleClass="table table-bordered table-hover"
      [loading]="loading"
      [scrollable]="true"
      scrollHeight="450px"
      styleClass="p-datatable-sm">

      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Reference No.</th>
          <th>Description</th>
          <th>Reference (Sales Receipt)</th>
          <th>Receipt From</th>
          <th>Module</th>
          <th class="text-end">Debit</th>
          <th class="text-end">Credit</th>
          <th class="text-end">Balance</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.journalDate | date:'yyyy-MM-dd' }}</td>
          <td>{{ row.referenceNo }}</td>
          <td>{{ row.strDescription }}</td>
          <td>{{ row.salesReceiptReferenceNo }}</td>
          <td>{{ row.receiptFrom }}</td>
          <td>{{ row.strType }}</td>
          <td class="text-end">{{ row.debit | number:'1.2-2' }}</td>
          <td class="text-end">{{ row.credit | number:'1.2-2' }}</td>
          <td class="text-end">{{ row.closingBalance | number:'1.2-2' }}</td>
        </tr>
      </ng-template>

    </p-table>

  </p-card>
</div>
